import cx from 'classnames'

export default function NewPaybarSpecialPriceLabel(props) {
  return (
    <div className={ cx('newPaybarSpecialPriceLabel', { is__large: this.props.isLarge })}>
      <p className="newPaybarSpecialPriceLabel-text">{ props.text}</p>
    </div>
  )
}
